import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledLoader = styled.div`
  min-height: ${({ $minHeight }) => $minHeight || "100px"};
`;

function Loader(props) {
  const { minHeight } = props;

  return (
    <StyledLoader
      className="d-flex justify-content-center align-items-center"
      $minHeight={minHeight}
    >
      <div className="spinner-border" role="status" />
    </StyledLoader>
  );
}

export default observer(Loader);

Loader.defaultProps = {
  minHeight: null,
};

Loader.propTypes = {
  minHeight: PropTypes.string,
};
